import Button from '@carvana/ds-button';
import React, { useState } from 'react';
import styles from './tasks-complete.module.css';

interface TasksCompleteProps {
  onContinue: () => void;
  showCheckmark?: boolean;
}

const TasksComplete: React.FC<TasksCompleteProps> = ({ onContinue }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    setIsLoading(true);
    onContinue();
  };

  return (
    <div className={styles.container}>
      <Button
        variant="primary"
        size="md"
        className={styles.cta}
        width="100%"
        onClick={handleClick}
        isLoading={isLoading}
        data-analytics-id="verification-tasks-complete-continue"
      >
        Continue
      </Button>
    </div>
  );
};

export default TasksComplete;
